(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/prescript.js');

'use strict';

svs.iam_login = svs.iam_login || {};
svs.iam_login.constants = svs.iam_login.constants || {};
svs.iam_login.utils = svs.iam_login.utils || {};
svs.iam_login.components = svs.iam_login.components || {};
svs.iam_login.components.shared = svs.iam_login.components.shared || {};
svs.iam_login.components.footer = svs.iam_login.components.footer || {};
svs.iam_login.components.bank_id = svs.iam_login.components.bank_id || {};
svs.iam_login.components.freja = svs.iam_login.components.freja || {};
svs.iam_login.components.media_queries = svs.iam_login.components.media_queries || {};
svs.iam_login.atoms = svs.iam_login.atoms || {};
svs.iam_login.utils.Dialogs = svs.iam_login.utils.Dialogs || {};
svs.iam_login.logger = new svs.core.log.Logger('module:iam-login');

 })(window);